"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._typecheckWMSErrorLoader = exports.WMSErrorLoader = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _parseWms = require("./lib/wms/parse-wms");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var VERSION = typeof "3.3.2" !== 'undefined' ? "3.3.2" : 'latest';
var WMSErrorLoader = {
  id: 'wms-error',
  name: 'WMS Error',
  module: 'wms',
  version: VERSION,
  worker: false,
  extensions: ['xml'],
  mimeTypes: ['application/vnd.ogc.se_xml', 'application/xml', 'text/xml'],
  testText: testXMLFile,
  options: {
    wms: {
      throwOnError: false
    }
  },
  parse: function () {
    var _parse = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(arrayBuffer, options) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _parseTextSync(new TextDecoder().decode(arrayBuffer), options));
            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    function parse(_x, _x2) {
      return _parse.apply(this, arguments);
    }
    return parse;
  }(),
  parseSync: function parseSync(arrayBuffer, options) {
    return _parseTextSync(new TextDecoder().decode(arrayBuffer), options);
  },
  parseTextSync: function parseTextSync(text, options) {
    return _parseTextSync(text, options);
  }
};
exports.WMSErrorLoader = WMSErrorLoader;
function testXMLFile(text) {
  return text.startsWith('<?xml');
}
function _parseTextSync(text, options) {
  var wmsOptions = _objectSpread(_objectSpread({}, WMSErrorLoader.options.wms), options === null || options === void 0 ? void 0 : options.wms);
  var error = (0, _parseWms.parseWMSError)(text, wmsOptions);
  var message = wmsOptions.minimalErrors ? error : "WMS Service error: ".concat(error);
  if (wmsOptions.throwOnError) {
    throw new Error(message);
  }
  return message;
}
var _typecheckWMSErrorLoader = WMSErrorLoader;
exports._typecheckWMSErrorLoader = _typecheckWMSErrorLoader;
//# sourceMappingURL=wms-error-loader.js.map